import styled from "styled-components"

import { minWidth } from "utils"

import Grid from "components/grid"
import ArticleCard from "../article-card"

export const DesktopWrapper = styled.div`
  display: none;

  ${minWidth.desktop`
    display: block;
  `}
`

export const StyledGrid = styled(Grid)`
  padding: 0 !important;

  ${minWidth.desktopL`
    padding: 0 5rem;
  `}
`

export const StyledCard = styled(ArticleCard)`
  /* header */
  > div {
    padding: 2rem 0 3rem;
  }
`

export const MobileWrapper = styled.div`
  margin: 2.5rem 0;

  ${minWidth.desktop`
    display: none;
  `}
`

export const BigCard = styled(ArticleCard)`
  margin: 0 0 1.3rem !important;
`

export const SmallCard = styled(ArticleCard)`
  margin: 0 !important;

  /* header */
  > div {
    padding: 1.3rem 0 2rem;
  }
`

export const Line = styled.div`
  width: 100%;
  height: 0.1rem;
  margin-top: 2rem;
  background-color: #222;
`
